export const FESTIVALS_2026 = [
  {
    slug: "makara-sankranti",
    nameEn: "Makara Sankranti", nameKn: "ಮಕರ ಸಂಕ್ರಾಂತಿ",
    date: "2026-01-14", dateText: "Wednesday, January 14, 2026",
    img: "/stotra-art/sankranti.jpg",
    significance: {
      kn: "ಸೂರ್ಯನು ಮಕರ ರಾಶಿಗೆ ಪ್ರವೇಶಿಸುವ ಪುಣ್ಯದಿನ — ಉತ್ತರಾಯಣದ ಆರಂಭ. ಎಳ್ಳು-ಬೆಲ್ಲ ಹಂಚಿ 'ಎಳ್ಳು ಬೆಲ್ಲ ತಿಂದು ಒಳ್ಳೆ ಮಾತನಾಡು' ಎಂದು ಹಾರೈಸುವ ಸುಗ್ಗಿಯ ಹಬ್ಬ.",
      en: "The day the Sun enters Makara rashi, beginning the auspicious Uttarayana. Karnataka's harvest festival of sharing ellu-bella (sesame and jaggery) with the wish 'speak sweetly like this sweet'.",
    },
    vidhi: ["Sunrise bath and Surya arghya (offering water to the Sun)", "Ellu-bella exchange with neighbours and family", "Pongal/sweet rice naivedya", "Godaana or annadaana (charity) is especially meritorious today"],
    relatedStotras: ["nitya-shlokagalu", "venkateshwara-suprabhatam", "vishnu-sahasranama"],
    prepare: [
      "Buy ellu-bella ingredients: white sesame, jaggery, dry coconut, fried gram and sugar-candy (sakkare achchu) moulds",
      "Arrange sugarcane, ber fruit and a new pot for pongal naivedya",
      "Keep sesame oil ready for the early morning bath before Surya arghya",
      "Clean the pooja room and keep Surya / Lakshmi idols and a kalasha ready",
      "Plan daana in advance — rice, clothes, sesame and jaggery to give as charity",
    ],
    faqs: [
      { q: "When is Makara Sankranti in 2026?", a: "Makara Sankranti falls on Wednesday, January 14, 2026 — the day the Sun enters Makara (Capricorn), beginning Uttarayana." },
      { q: "What is ellu-bella?", a: "A Karnataka Sankranti tradition — a mix of sesame seeds, jaggery, dry coconut, fried gram and peanuts shared with the words 'ellu bella tindu olle maathadu' (eat this and speak sweetly)." },
      { q: "Which pooja is done on Sankranti?", a: "Surya aradhana at sunrise, followed by naivedya of pongal. Many families also perform a simple Lakshmi pooja and charity (daana) of food and clothes." },
    ],
  },
  {
    slug: "maha-shivaratri",
    nameEn: "Maha Shivaratri", nameKn: "ಮಹಾ ಶಿವರಾತ್ರಿ",
    date: "2026-02-15", dateText: "Sunday, February 15, 2026",
    img: "/stotra-art/shivaratri.jpg",
    significance: {
      kn: "ಶಿವ-ಪಾರ್ವತಿಯರ ಕಲ್ಯಾಣದ ರಾತ್ರಿ; ಜಾಗರಣೆ, ಉಪವಾಸ ಮತ್ತು ನಾಲ್ಕು ಯಾಮಗಳ ರುದ್ರಾಭಿಷೇಕದಿಂದ ಶಿವನನ್ನು ಆರಾಧಿಸುವ ಮಹಾಪರ್ವ.",
      en: "The great night of Shiva — observed with fasting, night-long jagarane and abhisheka to the Shiva Linga through the four yamas (quarters) of the night with bilva leaves.",
    },
    vidhi: ["Fast through the day (phalahara permitted per family custom)", "Rudrabhisheka with milk, honey, curd and bilva leaves", "Recite Shiva Panchakshara, Lingashtakam and Bilvashtakam", "Night vigil (jagarane) with 'Om Namah Shivaya' japa through four yamas"],
    relatedStotras: ["shiva-panchakshara", "lingashtakam", "bilvashtakam", "shiva-ashtottara"],
    prepare: [
      "Collect fresh bilva (bilipatre) leaves — enough for the four yamas of abhisheka",
      "Buy milk, curd, honey, ghee, sugar and coconut water for the panchamrita abhisheka",
      "Keep a Shiva Linga, a copper kalasha and abhisheka vessels ready",
      "Arrange fruits and phalahara items in advance for the day-long fast",
      "Prepare for the night vigil (jagarane) — lamps, mats and 'Om Namah Shivaya' japa mala",
      "Book your purohith early for a home Rudrabhisheka on Feb 15",
    ],
    faqs: [
      { q: "When is Maha Shivaratri in 2026?", a: "Maha Shivaratri falls on Sunday, February 15, 2026. The main pooja is performed at night, across the four yamas." },
      { q: "Which stotras are recited on Shivaratri?", a: "Shiva Panchakshara Stotram, Lingashtakam, Bilvashtakam and Shiva Ashtottara Shatanamavali, along with continuous 'Om Namah Shivaya' japa." },
      { q: "Can Rudrabhisheka be done at home?", a: "Yes — with a Shiva Linga, bilva leaves and abhisheka dravyas. A purohith can perform the full Rudrabhisheka with Namaka-Chamaka chanting at your home." },
    ],
  },
  {
    slug: "ugadi",
    nameEn: "Ugadi (Kannada New Year)", nameKn: "ಯುಗಾದಿ",
    date: "2026-03-19", dateText: "Thursday, March 19, 2026",
    img: "/stotra-art/ugadi.jpg",
    significance: {
      kn: "ಚಾಂದ್ರಮಾನ ಹೊಸ ವರ್ಷದ ಮೊದಲ ದಿನ — ಬೇವು-ಬೆಲ್ಲ ಸವಿದು ಸುಖ-ದುಃಖಗಳೆರಡನ್ನೂ ಸಮನಾಗಿ ಸ್ವೀಕರಿಸುವ ಸಂಕಲ್ಪದ ಹಬ್ಬ. ಪಂಚಾಂಗ ಶ್ರವಣ ಈ ದಿನದ ವಿಶೇಷ.",
      en: "The Kannada lunar new year — welcomed with bevu-bella (neem and jaggery), symbolising equanimity in joy and sorrow, and the traditional Panchanga Shravana (hearing the year's almanac).",
    },
    vidhi: ["Oil bath at dawn and new clothes", "Door decorated with mango-leaf torana", "Bevu-bella naivedya and distribution", "Panchanga Shravana — hearing the new year's forecast from a purohith"],
    relatedStotras: ["ganesha-ashtottara", "vishnu-sahasranama", "nitya-shlokagalu"],
    prepare: [
      "Buy fresh neem flowers / tender leaves and jaggery for bevu-bella",
      "Get mango leaves for the door torana and fresh flowers for the pooja",
      "Keep new clothes and oil ready for the dawn abhyanga snana",
      "Plan festive naivedya in advance — obbattu / holige and mavinakayi chitranna",
      "Arrange a Panchanga (almanac) or book a purohith for Panchanga Shravana",
    ],
    faqs: [
      { q: "When is Ugadi in 2026?", a: "Ugadi falls on Thursday, March 19, 2026 — the first day of Chaitra masa, beginning the new samvatsara." },
      { q: "What is Panchanga Shravana?", a: "The traditional hearing of the new year's almanac — rainfall, harvest and rashi predictions — read by a purohith on Ugadi day, after the kalasha pooja." },
      { q: "Why is bevu-bella eaten on Ugadi?", a: "The neem's bitterness and jaggery's sweetness together remind us to accept both sorrow and joy with the same mind in the coming year." },
    ],
  },
  {
    slug: "rama-navami",
    nameEn: "Rama Navami", nameKn: "ಶ್ರೀರಾಮ ನವಮಿ",
    date: "2026-03-26", dateText: "Thursday, March 26, 2026",
    img: "/stotra-art/vishnu.jpg",
    significance: {
      kn: "ಚೈತ್ರ ಶುದ್ಧ ನವಮಿಯಂದು ಶ್ರೀರಾಮಚಂದ್ರನ ಜನ್ಮದಿನ. ಪಾನಕ-ಕೋಸಂಬರಿ ವಿತರಣೆ ಮತ್ತು ರಾಮನಾಮ ಸ್ಮರಣೆ ಕರ್ನಾಟಕದ ವಿಶೇಷ ಸಂಪ್ರದಾಯ.",
      en: "The birth of Lord Rama on Chaitra Shuddha Navami. In Karnataka, celebrated with panaka and kosambari distribution, Rama pooja at noon and continuous Rama-nama smarana.",
    },
    vidhi: ["Rama pooja at madhyahna (noon) — the muhurtha of Rama's birth", "Panaka (jaggery-lemon drink) and kosambari naivedya", "Ramayana parayana or Rama-nama japa", "Hanuman worship — no Rama pooja is complete without it"],
    relatedStotras: ["hanuman-chalisa", "vishnu-sahasranama", "venkateshwara-ashtottara"],
    parayana: "Vishnu Sahasranama",
    prepare: [
      "Buy ingredients for panaka — jaggery, lemon, dry ginger and cardamom",
      "Buy kosambari ingredients — split moong dal, cucumber and grated coconut",
      "Keep a Rama parivara photo or idol, tulasi and a decorated mantapa ready",
      "Arrange flowers and fruits, and plan the pooja for madhyahna (noon)",
      "Keep a Ramayana / Hanuman Chalisa text ready for parayana",
    ],
    faqs: [
      { q: "When is Rama Navami in 2026?", a: "Sri Rama Navami falls on Thursday, March 26, 2026 (smartha tradition). The main pooja is performed at noon, Rama's birth muhurtha." },
      { q: "Why are panaka and kosambari offered?", a: "Rama Navami falls in the peak of summer — the cooling jaggery-lemon panaka and moong kosambari are offered to the Lord and distributed to devotees." },
      { q: "Which stotras suit Rama Navami?", a: "Hanuman Chalisa, Vishnu Sahasranama and Rama raksha shlokas — Hanuman worship is considered essential alongside Rama pooja." },
    ],
  },
  {
    slug: "naga-panchami",
    nameEn: "Naga Panchami", nameKn: "ನಾಗರ ಪಂಚಮಿ",
    date: "2026-08-16", dateText: "Sunday, August 16, 2026",
    img: "/stotra-art/naga.jpg",
    significance: {
      kn: "ಶ್ರಾವಣ ಶುದ್ಧ ಪಂಚಮಿಯಂದು ನಾಗದೇವತೆಗಳ ಆರಾಧನೆ — ನಾಗನ ಕಲ್ಲಿಗೆ ಹಾಲೆರೆದು ಕುಟುಂಬದ ಕ್ಷೇಮ, ಸಂತಾನ ಸೌಭಾಗ್ಯಕ್ಕಾಗಿ ಪ್ರಾರ್ಥಿಸುವ ಹಬ್ಬ.",
      en: "Worship of the Naga devatas on Shravana Shuddha Panchami — milk is offered on naga stones under the ashwattha tree, praying for family welfare and progeny.",
    },
    vidhi: ["Tanige (milk offering) on naga stones with turmeric and kumkuma", "Arishina-kumkuma and flowers to the naga idol", "Kadubu/nucchina unde naivedya per family custom", "Sarpa dosha parihara poojas are often performed today"],
    relatedStotras: ["shiva-ashtottara", "nitya-shlokagalu", "sankata-nashana-ganesha"],
    prepare: [
      "Arrange milk, turmeric, kumkuma and flowers for the naga stone tanige",
      "Buy ingredients for kadubu / nucchina unde naivedya",
      "Keep a silver naga idol ready, or locate the nearest naga katte / ashwattha tree",
      "Prepare arishina-kumkuma and a clean pooja plate the day before",
      "Consult a purohith in advance if you plan a sarpa dosha parihara pooja",
    ],
    faqs: [
      { q: "When is Naga Panchami in 2026?", a: "Naga Panchami falls on Sunday, August 16, 2026 — the fifth day of Shravana shukla paksha." },
      { q: "What is offered on Naga Panchami?", a: "Milk (tanige), turmeric, kumkuma and flowers are offered on naga stones or silver naga idols, along with kadubu naivedya in Karnataka homes." },
      { q: "Is Naga Panchami linked to sarpa dosha?", a: "Yes — many families perform sarpa samskara or ashlesha bali related parihara poojas on this day with a purohith's guidance." },
    ],
  },
  {
    slug: "varamahalakshmi-vrata",
    nameEn: "Varamahalakshmi Vrata", nameKn: "ವರಮಹಾಲಕ್ಷ್ಮೀ ವ್ರತ",
    date: "2026-08-21", dateText: "Friday, August 21, 2026",
    img: "/stotra-art/lakshmi.jpg",
    significance: {
      kn: "ಶ್ರಾವಣ ಮಾಸದ ಎರಡನೇ ಶುಕ್ರವಾರ ಮಹಾಲಕ್ಷ್ಮಿಯನ್ನು ಕಲಶದಲ್ಲಿ ಆವಾಹಿಸಿ ಪೂಜಿಸುವ ವ್ರತ — ಸುಮಂಗಲಿಯರು ಕುಟುಂಬದ ಸೌಭಾಗ್ಯಕ್ಕಾಗಿ ಆಚರಿಸುವ ಕರ್ನಾಟಕದ ಪ್ರಮುಖ ಹಬ್ಬ.",
      en: "On the second Friday of Shravana, Mahalakshmi is invoked in a decorated kalasha and worshipped — one of Karnataka's most beloved vratas, observed by women for the family's prosperity.",
    },
    vidhi: ["Kalasha sthapana with rice, coins and mango leaves; decorated with a Lakshmi face and saree", "Shodashopachara pooja with lotus and kumkuma archane", "Recite Mahalakshmi Ashtakam and Lakshmi Ashtottara", "Tie the sacred doradarshana (yellow thread) on the wrist; offer 12 varieties of naivedya per custom"],
    relatedStotras: ["mahalakshmi-ashtakam", "lakshmi-ashtottara", "lalitha-sahasranama"],
    parayana: "Lalitha Sahasranama",
    prepare: [
      "Buy a kalasha, coconut, mango leaves, rice, coins and a Lakshmi face / mask",
      "Arrange a new saree, blouse-piece, bangles and flowers to decorate the kalasha",
      "Keep lotus, kumkuma and the sacred doradarshana (yellow thread) ready",
      "Plan the 12 varieties of naivedya per your family custom",
      "Book a purohith in advance for kalasha avahana and the full vrata vidhi on Aug 21",
    ],
    faqs: [
      { q: "When is Varamahalakshmi Vrata in 2026?", a: "Varamahalakshmi Vrata falls on Friday, August 21, 2026 — the Friday before Shravana purnima." },
      { q: "Which stotras are recited for Varamahalakshmi?", a: "Mahalakshmi Ashtakam, Lakshmi Ashtottara Shatanamavali and, for extended parayana, Lalitha Sahasranama." },
      { q: "Can Varamahalakshmi pooja be done at home without a purohith?", a: "Yes, many families perform it themselves — but a purohith brings the complete vidhi, sankalpa and kalasha avahana, which many households prefer for this vrata." },
    ],
  },
  {
    slug: "krishna-janmashtami",
    nameEn: "Krishna Janmashtami", nameKn: "ಶ್ರೀಕೃಷ್ಣ ಜನ್ಮಾಷ್ಟಮಿ",
    date: "2026-09-03", dateText: "Thursday, September 3, 2026 (Smartha) · Friday, September 4 (Vaishnava)",
    img: "/stotra-art/krishna.jpg",
    significance: {
      kn: "ಶ್ರಾವಣ ಕೃಷ್ಣ ಅಷ್ಟಮಿಯ ಮಧ್ಯರಾತ್ರಿ ಶ್ರೀಕೃಷ್ಣನ ಜನನ. ಮನೆಗಳಲ್ಲಿ ಕೃಷ್ಣನ ಪುಟ್ಟ ಹೆಜ್ಜೆ ಬರೆದು, ಬೆಣ್ಣೆ-ಅವಲಕ್ಕಿ ನೈವೇದ್ಯದೊಂದಿಗೆ ಮಧ್ಯರಾತ್ರಿ ಪೂಜೆ.",
      en: "Krishna's birth at midnight of Shravana Krishna Ashtami. Homes draw tiny butter-smeared footprints leading to the altar and offer butter, avalakki and milk sweets at the midnight pooja.",
    },
    vidhi: ["Fast until the midnight birth muhurtha (per family custom)", "Draw Krishna's footprints from the door to the pooja room", "Abhisheka to baby Krishna idol with milk, curd and honey", "Butter, avalakki (beaten rice) and milk sweets naivedya at midnight"],
    relatedStotras: ["vishnu-sahasranama", "venkateshwara-suprabhatam", "nitya-shlokagalu"],
    parayana: "Vishnu Sahasranama",
    prepare: [
      "Buy butter, avalakki (beaten rice), milk and curd, and ingredients for seedai / chakli",
      "Keep a baby Krishna idol or cradle and rangoli powder for the footprints",
      "Arrange flowers, tulasi and a decorated jhoola / mantapa",
      "Prepare naivedya and lamps in advance for the midnight birth pooja",
      "Plan the day's fasting food (phalahara) per family custom",
    ],
    faqs: [
      { q: "When is Krishna Janmashtami in 2026?", a: "September 3, 2026 (Thursday) in the smartha tradition; Vaishnava/ISKCON tradition observes it on September 4, 2026." },
      { q: "Why is pooja done at midnight?", a: "Krishna was born at midnight in Rohini nakshatra — the main abhisheka and naivedya are timed to that muhurtha." },
      { q: "What naivedya is offered?", a: "Butter, avalakki, milk sweets, seedai and fruits — foods beloved of baby Krishna." },
    ],
  },
  {
    slug: "ganesha-chaturthi",
    nameEn: "Ganesha Chaturthi", nameKn: "ಗಣೇಶ ಚತುರ್ಥಿ",
    date: "2026-09-14", dateText: "Monday, September 14, 2026",
    img: "/stotra-art/ganesha.jpg",
    significance: {
      kn: "ಭಾದ್ರಪದ ಶುದ್ಧ ಚತುರ್ಥಿಯಂದು ಗೌರಿಪುತ್ರ ಗಣೇಶನ ಪ್ರತಿಷ್ಠಾಪನೆ — ಮಣ್ಣಿನ ಮೂರ್ತಿಗೆ ಪ್ರಾಣಪ್ರತಿಷ್ಠೆ, ೨೧ ಪತ್ರೆ-ಪುಷ್ಪ ಪೂಜೆ, ಮೋದಕ ನೈವೇದ್ಯ.",
      en: "Installation of the clay Ganesha on Bhadrapada Shuddha Chaturthi — prana pratishthapana, worship with 21 sacred leaves and flowers, and the beloved modaka naivedya. Preceded by Gowri Habba.",
    },
    vidhi: ["Clay Ganesha sthapana with prana pratishtha", "Ekavimshati patra pooja — 21 sacred leaves", "Modaka, kadubu and chakkuli naivedya", "Visarjana after 1, 3, 5, 7 or 11 days per family custom"],
    relatedStotras: ["ganesha-ashtottara", "ganesha-pancharatna", "sankata-nashana-ganesha"],
    prepare: [
      "Order a clay (mannina) Ganesha idol in advance — avoid PoP",
      "Collect the 21 sacred leaves (ekavimshati patre) and durva grass",
      "Buy ingredients for modaka, kadubu and chakkuli naivedya",
      "Arrange a decorated mantapa, red flowers and fruits",
      "Book a purohith for prana pratishtha and decide your visarjana day (1 / 3 / 5 / 7 / 11)",
    ],
    faqs: [
      { q: "When is Ganesha Chaturthi in 2026?", a: "Ganesha Chaturthi falls on Monday, September 14, 2026. Gowri Habba is observed the day before, on September 13." },
      { q: "Which stotras are recited for Ganesha Chaturthi?", a: "Ganesha Ashtottara Shatanamavali, Ganesha Pancharatna Stotram and Sankata Nashana Ganesha Stotram." },
      { q: "Can a purohith perform the sthapana at home?", a: "Yes — the prana pratishtha, 21-patra pooja and visarjana sankalpa are traditionally led by a purohith at home." },
    ],
  },
  {
    slug: "navaratri-dasara",
    nameEn: "Navaratri & Vijayadashami (Dasara)", nameKn: "ನವರಾತ್ರಿ · ವಿಜಯದಶಮಿ",
    date: "2026-10-11", dateText: "October 11 – 20, 2026 (Vijayadashami: Tuesday, Oct 20)",
    img: "/stotra-art/lalitha.jpg",
    significance: {
      kn: "ಒಂಬತ್ತು ರಾತ್ರಿ ದೇವಿಯ ಆರಾಧನೆ — ಮನೆಮನೆಗಳಲ್ಲಿ ಗೊಂಬೆ ಹಬ್ಬ, ಸರಸ್ವತಿ ಪೂಜೆ, ಆಯುಧ ಪೂಜೆ ಮತ್ತು ವಿಜಯದಶಮಿ. ಕರ್ನಾಟಕದ ನಾಡಹಬ್ಬ ದಸರಾ.",
      en: "Nine nights of Devi worship — gombe habba (doll displays), Saraswati pooja, Ayudha pooja and Vijayadashami. Dasara is Karnataka's nadahabba, celebrated grandly in Mysuru.",
    },
    vidhi: ["Kalasha sthapana on day one and daily Devi pooja", "Lalitha Sahasranama or Devi Mahatmya parayana", "Saraswati pooja (Moola nakshatra) and Ayudha pooja (Navami)", "Vijayadashami — shami pooja and new beginnings (vidyarambha)"],
    relatedStotras: ["lalitha-sahasranama", "lakshmi-ashtottara", "mahalakshmi-ashtakam"],
    parayana: "Lalitha Sahasranama",
    prepare: [
      "Set up the gombe (doll) display steps (padi) and arrange your bombe collection",
      "Buy a kalasha, coconut, navadhanya and a new saree for Devi",
      "Keep a Lalitha Sahasranama / Devi Mahatmya text ready for daily parayana",
      "Prepare bagina items — haldi-kumkum, bangles, mirror and comb — for sumangalis",
      "Arrange books / instruments for Saraswati pooja and tools / vehicles for Ayudha pooja",
    ],
    faqs: [
      { q: "When is Navaratri in 2026?", a: "Sharad Navaratri begins Sunday, October 11, 2026 and culminates in Vijayadashami on Tuesday, October 20, 2026." },
      { q: "Which parayana is done during Navaratri?", a: "Lalitha Sahasranama and Durga Saptashati (Devi Mahatmya) are the principal parayanas; many also perform Chandi homa." },
      { q: "What is Ayudha Pooja?", a: "On Mahanavami, tools, vehicles and instruments of livelihood are cleaned and worshipped — a purohith performs the sankalpa and pooja at homes and offices." },
    ],
  },
  {
    slug: "deepavali",
    nameEn: "Deepavali (Lakshmi Pooja)", nameKn: "ದೀಪಾವಳಿ",
    date: "2026-11-08", dateText: "Sunday, November 8, 2026 (Lakshmi Pooja) · Balipadyami: Nov 10",
    img: "/stotra-art/daily.jpg",
    significance: {
      kn: "ಬೆಳಕಿನ ಹಬ್ಬ — ನರಕ ಚತುರ್ದಶಿಯ ಅಭ್ಯಂಗ ಸ್ನಾನ, ಅಮಾವಾಸ್ಯೆಯ ಲಕ್ಷ್ಮೀ ಪೂಜೆ ಮತ್ತು ಬಲಿಪಾಡ್ಯಮಿ. ಮನೆ-ಅಂಗಡಿಗಳಲ್ಲಿ ದೀಪ ಬೆಳಗಿಸಿ ಲಕ್ಷ್ಮಿಯನ್ನು ಸ್ವಾಗತಿಸುವ ಪರ್ವ.",
      en: "The festival of lights — Naraka Chaturdashi oil bath, Lakshmi Pooja on amavasya evening, and Balipadyami. Homes and businesses light rows of lamps to welcome Lakshmi.",
    },
    vidhi: ["Abhyanga snana (oil bath) on Naraka Chaturdashi", "Lakshmi pooja at pradosha time with lamps in every doorway", "Business owners perform Lakshmi-Kubera pooja and open new account books", "Balipadyami — Bali pooja and Govardhana pooja"],
    relatedStotras: ["lakshmi-ashtottara", "mahalakshmi-ashtakam", "nitya-shlokagalu"],
    parayana: "Lalitha Sahasranama for Lakshmi",
    prepare: [
      "Buy oil, ubtan and fragrances for the Naraka Chaturdashi abhyanga snana",
      "Stock diyas, wicks, oil and rangoli colours for the rows of lamps",
      "Buy new account books (chopdi) if performing Lakshmi-Kubera pooja for business",
      "Arrange a Lakshmi idol / photo, lotus, kumkuma and festive naivedya",
      "Plan Balipadyami / Govardhana pooja items for Nov 10",
    ],
    faqs: [
      { q: "When is Deepavali Lakshmi Pooja in 2026?", a: "Lakshmi Pooja falls on Sunday, November 8, 2026, during pradosha kala. Naraka Chaturdashi is on November 7 and Balipadyami on November 10." },
      { q: "Which stotras are recited on Deepavali?", a: "Lakshmi Ashtottara Shatanamavali and Mahalakshmi Ashtakam during the evening Lakshmi pooja; businesses add Lakshmi-Kubera mantras." },
      { q: "When should lamps be lit?", a: "From pradosha (twilight) onwards — rows of deepas at doorways, windows and the tulasi katte welcome Lakshmi into the home." },
    ],
  },
];

// 2027 dates (Karnataka panchanga). 2027 pages reuse the same vidhi/prepare/stotras.
const DATES_2027 = {
  "makara-sankranti": ["2027-01-15", "Friday, January 15, 2027"],
  "maha-shivaratri": ["2027-03-06", "Saturday, March 6, 2027"],
  "ugadi": ["2027-04-07", "Wednesday, April 7, 2027"],
  "rama-navami": ["2027-04-15", "Thursday, April 15, 2027"],
  "naga-panchami": ["2027-08-06", "Friday, August 6, 2027"],
  "varamahalakshmi-vrata": ["2027-08-13", "Friday, August 13, 2027"],
  "krishna-janmashtami": ["2027-08-25", "Wednesday, August 25, 2027"],
  "ganesha-chaturthi": ["2027-09-04", "Saturday, September 4, 2027"],
  "navaratri-dasara": ["2027-09-30", "Sep 30 – Oct 9, 2027 (Vijayadashami Oct 9)"],
  "deepavali": ["2027-10-29", "Friday, October 29, 2027 (Lakshmi Pooja)"],
};

const ART = {
  "makara-sankranti": "https://static.prod-images.emergentagent.com/jobs/d91360cc-5e43-43d9-9fd6-904640282dce/images/3efa8911935d0f0ba139a7afcea32eb19148f5e53c718c7399b8487ec991c36c.jpeg",
  "maha-shivaratri": "https://static.prod-images.emergentagent.com/jobs/d91360cc-5e43-43d9-9fd6-904640282dce/images/e27e14576df7fe9ab28db7a79bc442944ea761020e3503a394675f213491c2bd.jpeg",
  "ugadi": "https://static.prod-images.emergentagent.com/jobs/d91360cc-5e43-43d9-9fd6-904640282dce/images/d48d9fa0fece2952170e65f8794438c2c91ceffb976da2824b67e9e8b313914f.jpeg",
  "rama-navami": "https://static.prod-images.emergentagent.com/jobs/d91360cc-5e43-43d9-9fd6-904640282dce/images/10699bdecaf3b30df70fe03bd542e8c08f5bddb4316d68870c5cafa1837a3309.jpeg",
  "naga-panchami": "https://static.prod-images.emergentagent.com/jobs/d91360cc-5e43-43d9-9fd6-904640282dce/images/0cc64824e14a1e289c92e6aa0aafcb053ef120c3f0aa5713a666f813f4212780.jpeg",
  "varamahalakshmi-vrata": "https://static.prod-images.emergentagent.com/jobs/d91360cc-5e43-43d9-9fd6-904640282dce/images/12b6eb96b702d1d16fbcf8d5fc870fd119d97e1215123997da3fbb3f9b568adc.jpeg",
  "krishna-janmashtami": "https://static.prod-images.emergentagent.com/jobs/d91360cc-5e43-43d9-9fd6-904640282dce/images/050cb762e377cd7bbe021416ce86c05fbb628f4a1d84e5120a8c35d74c614c12.jpeg",
  "ganesha-chaturthi": "https://static.prod-images.emergentagent.com/jobs/d91360cc-5e43-43d9-9fd6-904640282dce/images/0efa0ae3c439ca9f49482f521f4723f8456b6cec54a04b3abb2a196e7dfb19a4.jpeg",
  "navaratri-dasara": "https://static.prod-images.emergentagent.com/jobs/d91360cc-5e43-43d9-9fd6-904640282dce/images/1938f04a0b78fd630e127d6ce46259b8d3f0ef0f6348e86532a7b30947a96826.jpeg",
  "deepavali": "https://static.prod-images.emergentagent.com/jobs/d91360cc-5e43-43d9-9fd6-904640282dce/images/2a03c5701963eeaaf15bcb26552003c7615a4a5a11afb3d6a3c61d7708fa3ad0.jpeg",
};

const MUHURTA = {
  "makara-sankranti": "Punya kala is the hours around sunrise — perform Surya arghya and daana soon after your morning bath.",
  "maha-shivaratri": "The main pooja is in nishita kala (around midnight); devout families keep vigil through all four praharas of the night.",
  "ugadi": "Begin at dawn with abhyanga snana; Panchanga Shravana is best in the forenoon, after the pooja.",
  "rama-navami": "Sri Rama was born at madhyahna (solar noon) — the main pooja is performed around midday.",
  "naga-panchami": "Morning, after the bath — offer milk and abhisheka to the naga before noon.",
  "varamahalakshmi-vrata": "The kalasha avahana and vrata are done in the forenoon on the Friday before Shravana Purnima.",
  "krishna-janmashtami": "Sri Krishna appeared at midnight — the main pooja and arghya are offered in nishita kala (around 12 am).",
  "ganesha-chaturthi": "Madhyahna (midday) is the preferred muhurta for prana pratishtha; avoid viewing the moon this night.",
  "navaratri-dasara": "Ghatasthapana is done on the first morning; Saraswati, Ayudha and Vijayadashami rites follow in the daily forenoon.",
  "deepavali": "Lakshmi pooja is performed in pradosha kala (twilight, just after sunset) on amavasya.",
};

const FESTIVALS_2027 = FESTIVALS_2026.map((f) => {
  const d = DATES_2027[f.slug];
  return {
    ...f,
    slug: `${f.slug}-2027`,
    year: 2027,
    date: d[0],
    dateText: d[1],
    parayana: f.parayana,
    img: ART[f.slug] || f.img,
    muhurta: MUHURTA[f.slug],
    faqs: [
      { q: `When is ${f.nameEn} in 2027?`, a: `${f.nameEn} falls on ${d[1]}.` },
      ...f.faqs.filter((x) => !/\b20\d\d\b/.test(x.q) && !/\b20\d\d\b/.test(x.a)),
    ],
  };
});

const FESTIVALS_2026_TAGGED = FESTIVALS_2026.map((f) => ({ ...f, year: 2026, img: ART[f.slug] || f.img, muhurta: MUHURTA[f.slug] }));

export const FESTIVALS = [...FESTIVALS_2026_TAGGED, ...FESTIVALS_2027];

export const festivalBySlug = (slug) => FESTIVALS.find((f) => f.slug === slug);
